var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"jump-box"},[_c('div',{staticClass:"jump"},[_c('img',{attrs:{"src":require("@/assets/images/loading.gif"),"alt":""}}),_c('p',{staticStyle:{"font-size":"0.3rem"}},[_vm._v(" 正在跳转到支付页面，请稍候~ ")])])])
}]

export { render, staticRenderFns }